import { render, staticRenderFns } from "./eventsSelection.vue?vue&type=template&id=6d3765a6&class=app-bg-login&"
import script from "./eventsSelection.vue?vue&type=script&lang=ts&"
export * from "./eventsSelection.vue?vue&type=script&lang=ts&"
import style0 from "./eventsSelection.vue?vue&type=style&index=0&id=6d3765a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports